function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.67 17.89h-7.7c-.24 0-.46-.11-.6-.3a.742.742 0 01-.12-.66l3.08-10.78a.75.75 0 01.72-.54h3.04c.23 0 .45.11.6.29.14.19.19.43.13.65l-1.87 7h3.25c.22 0 .43.1.58.27.14.17.2.4.16.61l-.51 2.84c-.09.36-.4.62-.76.62zm-6.71-1.5h6.08l.24-1.34h-3.32c-.23 0-.45-.11-.6-.29a.763.763 0 01-.13-.65l1.87-7h-1.5l-2.64 9.28z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.32 13.27a.748.748 0 01-.14-1.48l7.7-1.54a.75.75 0 11.29 1.47l-7.7 1.54c-.05.01-.1.01-.15.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
})));